import { render } from "./Tarification_Solo.vue?vue&type=template&id=1accbe84"
import script from "./Tarification_Solo.vue?vue&type=script&lang=js"
export * from "./Tarification_Solo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__